/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_cards_fees_rule_amount_range = /** @type {(inputs: { min: NonNullable<unknown>, max: NonNullable<unknown> }) => string} */ (i) => {
	return `Monto entre $${i.min} y $${i.max} USD`
};

const en_cards_fees_rule_amount_range = /** @type {(inputs: { min: NonNullable<unknown>, max: NonNullable<unknown> }) => string} */ (i) => {
	return `Amount between $${i.min} and $${i.max} USD`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ min: NonNullable<unknown>, max: NonNullable<unknown> }} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cards_fees_rule_amount_range = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cards_fees_rule_amount_range(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cards_fees_rule_amount_range", locale)
	if (locale === "es") return es_cards_fees_rule_amount_range(inputs)
	return en_cards_fees_rule_amount_range(inputs)
};
export { cards_fees_rule_amount_range as "cards.fees.rule_amount_range" }